import React from 'react'
import ReactGA from 'react-ga'

import { Link } from 'react-router-dom'
import DocumentTitle from 'react-document-title'

// import { Spin, Alert } from 'antd'

import ajax from '../ControlPanel/utils/ajax'
import globalConfig from '../ControlPanel/config'
import QuillReadOnlyBlock from './QuillReadOnlyBlock'

import PropTypes from 'prop-types'
import { withStyles } from 'material-ui/styles'
import Card, { CardActions, CardContent } from 'material-ui/Card'
import Button from 'material-ui/Button'
import Typography from 'material-ui/Typography'
import { CircularProgress } from 'material-ui/Progress'
import Styles from '../../styles/Styles'

import classNames from 'classnames'

import '../../styles/Quill.scss'


class CommonBlockCard extends React.Component {
    constructor(props) {
        super(props)
    }

    textRouter(block, id) {
        let { text } = block
        return <QuillReadOnlyBlock text={text} id={id} />
    }

    render() {
        // (block, i)
        const { classes, overrideBlockRender, block, id } = this.props
        let { withBorder } = this.props
        withBorder = withBorder || false
        if (overrideBlockRender) {
            return overrideBlockRender(block, id)
        } else {
            const { title, authors, text } = block
            let authorsElems = null
            if (authors && authors.length > 0) {
                authorsElems = (<div className="TextShadow">
                    <strong>Authors:</strong>
                    <ul style={{ paddingLeft: '5%' }}>{[...authors.map((a, i) => <li key={i}>{a || ''}</li>)]}</ul>
                </div>)
            }
            const name = withBorder ? 'Section' : ''
            return (<div key={id} style={{ paddingBottom: '10px' }}>
                <Card className={classes.card}>
                    <CardContent>
                        <Typography variant="headline" component="h2">
                            {title || ''}
                        </Typography>
                        {authorsElems}
                    </CardContent>
                    <CardContent>
                        <Typography component="div">
                            {/* <span dangerouslySetInnerHTML={{ __html: text }} style={{ display: 'inline' }} /> */}
                            {this.textRouter(block, id)}
                        </Typography>
                    </CardContent>
                </Card>
            </div>)
        }
    }

}

CommonBlockCard.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(Styles)(CommonBlockCard)
